import type { PropsWithChildren, RefObject } from 'react'
import { useTheme } from 'styled-components'

import { Typography } from '../../Typography'

import { SegmentHeader, SegmentWrapper } from './Segment.Styled'

export type SegmentProps = PropsWithChildren<{
  containerRef?: RefObject<HTMLDivElement | null>
  subtitle?: string
  title?: string
}>

export const Segment = ({
  children,
  containerRef,
  subtitle,
  title,
}: SegmentProps) => {
  const theme = useTheme()

  return (
    <SegmentWrapper ref={containerRef}>
      {(title || subtitle) && (
        <SegmentHeader>
          {title && (
            <Typography
              dangerouslySetInnerHTML={{ __html: title }}
              $color={theme.colors['N Content/Primary']}
              $variant="Poppins/H3 - Medium"
              $textAlign="center"
            />
          )}
          {subtitle && (
            <Typography
              dangerouslySetInnerHTML={{ __html: subtitle }}
              $color={theme.colors['N Content/Secondary']}
              $variant="Poppins/T4 - Medium"
              $textAlign="center"
            />
          )}
        </SegmentHeader>
      )}
      {children}
    </SegmentWrapper>
  )
}
